"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdpManagementApiService = void 0;
const configuration_1 = require("@common/configuration");
const implicit_flow_service_1 = require("./base/implicit-flow.service");
class IdpManagementApiService extends implicit_flow_service_1.ImplicitFlowService {
    constructor() {
        super(configuration_1.FrontendConfiguration.idpManagementServiceConfig().url);
    }
    async searchIdpOwners(filter) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.get(`${this.apiUrl}/api/v1/idp/owners/${filter}`)).data;
        }
        catch (e) {
            this.logger.error("getIdpOwners error", e);
            return [];
        }
    }
    async searchIdpUsers(filter) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.get(`${this.apiUrl}/api/v1/idp/users/${filter}`)).data;
        }
        catch (e) {
            this.logger.error("getIdpUsers error", e);
            return [];
        }
    }
    async getIdpUsersByEmail(email) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.get(`${this.apiUrl}/api/v1/idp/users/email/${email}`)).data;
        }
        catch (e) {
            this.logger.error("getIdpUsers error", e);
            return null;
        }
    }
    async linkUsers(linkAccount) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.post(`${this.apiUrl}/api/v1/idp/link-users`, linkAccount)).data;
        }
        catch (e) {
            this.logger.error("linkUsers error", e);
            return null;
        }
    }
    async unlinkUsers(linkAccount) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.post(`${this.apiUrl}/api/v1/idp/unlink-users`, linkAccount)).data;
        }
        catch (e) {
            this.logger.error("unlinkUsers error", e);
            return null;
        }
    }
    async getConnectLoginsByContactsIds(contactsIds) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.get(`${this.apiUrl}/api/v1/connect/logins/contacts/${contactsIds.join(",")}`)).data;
        }
        catch (e) {
            this.logger.error("getConnectLoginsByContactsIds error", e);
            return [];
        }
    }
    async getConnectLoginsByEmail(email) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.get(`${this.apiUrl}/api/v1/connect/logins/email/${email}`)).data;
        }
        catch (e) {
            this.logger.error("getConnectLoginsByEmail error", e);
            return null;
        }
    }
    async validateLinkUsers(ownerAccount) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.post(`${this.apiUrl}/api/v1/idp/link-users/validate`, ownerAccount)).data;
        }
        catch (e) {
            this.logger.error("validateLinkUsers error", e);
            return null;
        }
    }
    async getChangeLogs(uuid) {
        try {
            const axios = await this.axiosInstance();
            return (await axios.get(`${this.apiUrl}/api/v1/idp/change-logs/${uuid}`)).data;
        }
        catch (e) {
            this.logger.error("validateLinkUsers error", e);
            return null;
        }
    }
}
exports.IdpManagementApiService = IdpManagementApiService;
//# sourceMappingURL=idp-management-api.service.js.map